import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Menu,
  MenuItem,
  Pagination,
  Card,
  CircularProgress,
} from "@mui/material";
import { AuthorizedLayout } from "../Layouts/AuthorizedLayout";
import SearchandExport from "../../Components/Common/SearchandExport/SearchandExport";
import ActionIcon from "../../Assets/images/png/Action.png";
import CameraIcon from "../../Assets/images/svg/Icons/camera-logo.svg";
import { GetApiMethod, DeleteApiMethod } from "../../Utils/ApiService";
import ProviderForm from "./ProviderForm";
import Bookings from "./Bookings";
import "../../Components/Common/Styles/Formstyles.css";
import BoxHeader from "../../Components/Common/Box/Boxheader";
import { useNavigate, useParams } from "react-router-dom";
import SuccessDialog from "../../Components/Common/SuccesMessages/SuccessDialog";
import { useSuccessDialog } from "../../Components/Common/SuccesMessages/SuccessDialog"; 
export interface Provide {
  id: string;
  providerName: string;
  contactPerson: any;
  email: any;
  phone: any;
  categories: any;
  categoriesOffered: string[];
  categoriesDetail?: { name: string }[];
}

const Providers = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [Providers, setProviders] = useState<Provide[]>([]);
  const [showtotalPages, setShowTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showProviders, setShowProviders] = useState<boolean>(true);
  const [selectedProvider] = useState<Provide | null>(null);
  const [showBookings, setShowBookings] = useState(false);
  const [showProviderForm, setShowProviderForm] = useState(false);
  const [, setEditStep] = useState("basicInfo");
  const navigate = useNavigate();
  const itemsPerPage = 5;
const { open: successOpen, message, showSuccess, closeSuccess } = useSuccessDialog();
 const { id } = useParams<{ id: string }>();
const isFetched = useRef(false);
  const [tab, setTab] = useState(0);
useEffect(() => {
  if (isFetched.current) return;
  isFetched.current = true;

  if (!id) {
    fetchProviders(currentPage, searchTerm);
  }
  return () => {
    isFetched.current = false;
  };
}, [currentPage, searchTerm, id]);
  const fetchProviders = async (page = 1, search = "") => {
    
    try {
      setLoading(true);
      console.log("Fetching providers → page:", page, "search:", search);
      const response = await GetApiMethod(
        `provider?page=${page}&limit=${itemsPerPage}&sort=createdAt&sortDirection=DESC&search=${search}&_=${Date.now()}`
      );
      console.log("API Response:", response?.data);
      const records = response?.data?.data?.records || [];
      const totalCount = response?.data?.data?.totalCount || 0;

      setProviders(records);
      setShowTotalPages(totalCount > 0 ? Math.ceil(totalCount / itemsPerPage) : 1);
    } catch (error) {
      console.error("Error fetching Providers:", error);
      
    }
    finally {
      setLoading(false);
    }
  };

// const fetchProviderById = async () => {
//   if (!id) return;
//   try {
//     const response = await GetApiMethod(`provider/${id}`);
//     const fetchedProvider = response?.data?.data?.provider;

//     if (fetchedProvider) {
//       setProviders([fetchedProvider]);
      
//     }
//   } catch (error) {
//     console.error("Error fetching provider:", error);
//   }
// };
// useEffect(() => {
//   if (id) {
//     fetchProviderById();
//   }
// }, [id]);

  // const totalPages = Math.ceil(filteredProviders.length / itemsPerPage);
  // const paginatedProviders = filteredProviders.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );
  const paginatedProviders = Providers;

  const [anchorEls, setAnchorEls] = useState<(null | HTMLElement)[]>([]);

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    index: number
  ) => {
    const newAnchors = [...anchorEls];
    newAnchors[index] = event.currentTarget;
    setAnchorEls(newAnchors);
  };

  const handleMenuClose = (index: number) => {
    const newAnchors = [...anchorEls];
    newAnchors[index] = null;
    setAnchorEls(newAnchors);
  };
  const handleView = (index: number) => {
    const selected = paginatedProviders[index];
    navigate(`/providers/${selected.id}/view`);
    handleMenuClose(index);
  };
  // const handleEdit = (index: number) => {
  //   const selected = paginatedProviders[index];
  //   navigate(`/providers/${selected.id}/edit`);
  //   handleMenuClose(index);
  // };
const handleDelete = async (index: number) => {
  const provider = Providers[index];
  if (!provider) return;
  try {
    const response = await DeleteApiMethod(`provider/${provider.id}`);
    if (response.status === 200 || response.status === 204) {
      // Remove the deleted provider from state
      const updatedProviders = [...Providers];
      updatedProviders.splice(index, 1);
      setProviders(updatedProviders);

      // Optionally update pagination count
      const totalCount = showtotalPages * itemsPerPage - 1;
      setShowTotalPages(totalCount > 0 ? Math.ceil(totalCount / itemsPerPage) : 1);

      // Show success message using hook
      showSuccess(`Provider "${provider.providerName}" deleted successfully.`);
    } else {
      showSuccess(`Failed to delete provider "${provider.providerName}".`);
    }
  } catch (error) {
    console.error("Error deleting provider:", error);
    showSuccess(`Error deleting provider "${provider.providerName}".`);
  } finally {
    handleMenuClose(index); 
  }
};

  return (
    <AuthorizedLayout>
      <Box sx={{ px: 2, py: 2 }}>
        <Box sx={{ width: "100%" }}>
            {loading && (
                    <Box className="loading-overlay">
                      <CircularProgress size={50} thickness={5} />
                    </Box>
                  )}
          <Card className="card-layout">
         <BoxHeader
  dashboard_name="Providers"
  image={CameraIcon}
  button_show={true}
  button_name="Add New Provider"
  onAdd={() =>
    navigate("/providers/add", {
    })
  }
  tabs={["All Providers"]}
  activeTab={tab}
  onTabChange={(newTab) => setTab(newTab)}
/>


            <Box mt={2}>
              {showBookings && selectedProvider && (
                <Bookings
                  providerId={selectedProvider.id}
                  onBack={() => {
                    setShowBookings(false);
                    setShowProviders(true);
                  }}
                  onEdit={(tabIndex) => {
                    const stepMap = ["basicInfo", "services", "addons", "photos", "videos"];
                    const step = stepMap[tabIndex] || "basicInfo";
                    setEditStep(step);
                    setShowBookings(false);
                    setShowProviderForm(true);
                  }}
                />
              )}

              {showProviderForm && <ProviderForm />}


              {showProviders && !showBookings && !showProviderForm && (
                <>
                  <SearchandExport
                    searchPlaceholder="Type here"
                    onSearchChange={(value: string) => {
                      setSearchTerm(value);
                      setCurrentPage(1);
                    }}
                  />
                  <Table className="table">
                    <TableHead>
                      <TableRow> 
                        {[
                          "Provider",
                          "Contact Person",
                          "Email ID",
                          "Phone Number",
                          "Categories Offered",
                          "Action",
                        ].map((col) => (
                          <TableCell
                            key={col}
                            className="table-header"
                          >
                            {col}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Providers.length > 0 ? (
                        Providers.map((provider, index) => (
                          <TableRow key={provider.id}>
                            <TableCell className="table-cell">{provider.providerName}</TableCell>
                            <TableCell className="table-cell">{provider.contactPerson}</TableCell>
                            <TableCell className="table-cell">{provider.email}</TableCell>
                            <TableCell className="table-cell">{provider.phone}</TableCell>
                            <TableCell className="table-cell">
                              {provider.categoriesDetail?.length
                                ? provider.categoriesDetail.map((cat) => cat.name).join(", ")
                                : "—"}
                            </TableCell>
                            <TableCell>
                              <Box display="flex" alignItems="center">
                                <Typography className="table-cell action">Action</Typography>
                                <IconButton onClick={(event) => handleMenuOpen(event, index)} className="action">
                                  <img src={ActionIcon} alt="action" />
                                </IconButton>
                              </Box>
                              <Menu
                                anchorEl={anchorEls[index]}
                                open={Boolean(anchorEls[index])}
                                onClose={() => handleMenuClose(index)}
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                transformOrigin={{ vertical: "top", horizontal: "right" }}
                              >
                                <MenuItem onClick={() => handleView(index)} className="view-menu-item">
                                  View
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    navigate(`/providers/${paginatedProviders[index].id}/edit?`, {
                                      state: { provider: paginatedProviders[index] },
                                    })
                                  }
                                  className="edit-menu-item"
                                >
                                  Edit
                                </MenuItem>


                                <MenuItem
                                  onClick={() => {
                                    handleDelete(index);
                                    handleMenuClose(index);
                                  }}
                                  className="delete-menu-item"
                                >
                                  Delete
                                </MenuItem>
                              </Menu>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={6} align="center">
                            No providers found.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <Box mt={2} display="flex" justifyContent="center">
                    <Pagination
                      count={showtotalPages}
                      page={currentPage}
                      onChange={(_, page) => setCurrentPage(page)}
                      color="primary"
                      size="small"
                      sx={{
                        "& .MuiPaginationItem-root": {
                          fontFamily: "Poppins, Regular",
                        },
                      }}
                    />


                  </Box>
                </>
              )}
            </Box>
          </Card>
        </Box>
      </Box>
      <SuccessDialog open={successOpen} onClose={closeSuccess} message={message} />

    </AuthorizedLayout>
  );
};
export default Providers;
